import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectOrganizationComponent } from './select-organization.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  declarations: [
    SelectOrganizationComponent
  ],
  exports: [
    SelectOrganizationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    DialogsModule,
    ButtonsModule,
    DropDownsModule
  ]
})
export class SelectOrganizationModule { }
